module.exports = __webpack_public_path__ + "static/img/radar_open.43bd8393.png";